import React, { useState } from "react";
import "./stiluri/ButonIstoric.css";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../pagini/Firebase";

const formatTimestamp = (timestampStr) => {
  if (!timestampStr) return "";
  try {
    const date = new Date(timestampStr);
    return date.toLocaleString();
  } catch {
    return "";
  }
};

const ButonIstoric = ({ id, numeComponenta }) => {
  const [loadingIstoric, setLoadingIstoric] = useState(false);
  const [errorIstoric, setErrorIstoric] = useState("");
  const [istoric, setIstoric] = useState([]);
  const [showIstoric, setShowIstoric] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [userNamesMap, setUserNamesMap] = useState({});

  // State pentru modal user details
  const [showUserModal, setShowUserModal] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

 // Fetch user details pentru modal (detalii complete)
  const fetchUserDetails = async (email) => {
    if (!email) return;
    try {
      const colRef = collection(db, "Utilizatori");
      const q = query(colRef, where("email", "==", email));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const userData = snapshot.docs[0].data();
        setUserDetails(userData);
        setShowUserModal(true);
      } else {
        setUserDetails({ nume: "Utilizator necunoscut" });
        setShowUserModal(true);
      }
    } catch (error) {
      console.error("Eroare la preluarea detaliilor utilizatorului:", error);
      setUserDetails({ nume: "Eroare la încărcare" });
      setShowUserModal(true);
    }
  };

  const obtineIstoricBeneficiar = async () => {
    if (!id || !numeComponenta) {
      setErrorIstoric("ID beneficiar sau nume componentă nu sunt furnizate.");
      return;
    }
    setLoadingIstoric(true);
    setErrorIstoric("");
    setIstoric([]);
    setShowIstoric(false);

    try {
      // URL-ul către funcția ta Cloud Function Gen1
      // Exemplu: "https://us-central1-TU-PROIECT.cloudfunctions.net/getIstoricBeneficiar"
      const url = `https://us-central1-epafa-production.cloudfunctions.net/ButonIstoric?beneficiaryId=${encodeURIComponent(
        id
      )}&numeComponenta=${encodeURIComponent(numeComponenta)}`;

      const response = await fetch(url);
      if (!response.ok) {
        const errData = await response.json();
          setLoadingIstoric(false);
        throw new Error(errData.error || "Eroare la încărcare istoric");
      }

      const data = await response.json();

      if (!data.istoric || data.istoric.length === 0) {
        setErrorIstoric("Nu există istoric pentru acest beneficiar și componentă.");
        setShowIstoric(false);
        setIstoric([]);
          setLoadingIstoric(false);
        return;
      }

      setIstoric(data.istoric);
      setUserNamesMap(data.userNamesMap || {});
      setCurrentPage(1);
      setShowIstoric(true);
    } catch (e) {
      setErrorIstoric("Eroare la citirea istoricului: " + e.message);
      setIstoric([]);
      setShowIstoric(false);
    }
      setLoadingIstoric(false);
  };

  const afiseazaValoare = (val) => {
    if (typeof val === "object" && val !== null) {
      try {
        return JSON.stringify(val, null, 2);
      } catch {
        return String(val);
      }
    }
    return String(val);
  };

  const totalPages = Math.ceil(istoric.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = istoric.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="buton-istoric-container">
<button
  onClick={obtineIstoricBeneficiar}
  disabled={loadingIstoric || !id || !numeComponenta}
  style={{ display: "flex", alignItems: "center", gap: "10px" }}
>
  {loadingIstoric && <div className="spinner"></div>}
  {loadingIstoric ? "Se încarcă istoricul..." : "Vezi Istoric Modificări"}
</button>



      {errorIstoric && <p style={{ color: "red" }}>{errorIstoric}</p>}

      {showIstoric && currentItems.length > 0 && (
        <div
          className="istoric-tabel-container"
          style={{ marginTop: "1rem", overflowX: "auto" }}
        >
          <h3>Istoric Modificări - {numeComponenta}</h3>
          <table
            className="istoric-tabel"
            style={{ width: "100%", borderCollapse: "collapse" }}
          >
            <thead>
              <tr style={{ borderBottom: "2px solid #333" }}>
                <th style={{ padding: "8px", textAlign: "left" }}>Câmp</th>
                <th style={{ padding: "8px", textAlign: "left" }}>Valoare veche</th>
                <th style={{ padding: "8px", textAlign: "left" }}>Valoare nouă</th>
                <th style={{ padding: "8px", textAlign: "left" }}>Utilizator</th>
                <th style={{ padding: "8px", textAlign: "left" }}>Data modificării</th>
                <th style={{ padding: "8px", textAlign: "left" }}>Motiv schimbare</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item) => {
                const userName = userNamesMap[item.utilizator];
                return (
                  <tr key={item.id} style={{ borderBottom: "1px solid #ccc" }}>
                    <td style={{ padding: "8px" }}>{item.camp}</td>
                    <td style={{ padding: "8px" }}>{afiseazaValoare(item.valoareVeche)}</td>
                    <td style={{ padding: "8px" }}>{afiseazaValoare(item.valoareNoua)}</td>
                    <td style={{ padding: "8px" }}>
                      <button
                        className="show-user-details"
                        onClick={() => fetchUserDetails(item.utilizator)}
                      >
                        {userName
                          ? `${userName.nume} ${userName.prenume}`
                          : item.utilizator}
                      </button>
                    </td>
                    <td style={{ padding: "8px" }}>
                      {formatTimestamp(item.data)}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        maxWidth: "300px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {item.motivSchimbare}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div
              style={{
                marginTop: "1rem",
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Pagina anterioară
              </button>
              <span>
                Pagina {currentPage} din {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Pagina următoare
              </button>
            </div>
          )}
        </div>
      )}

      {/* Modal detalii utilizator */}
      {showUserModal && userDetails && (
        <div
          className="modal"
          onClick={() => setShowUserModal(false)}
          style={{ cursor: "pointer" }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ cursor: "default" }}
          >
            <button
              onClick={() => setShowUserModal(false)}
              aria-label="Închide"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                fontSize: "1.8rem",
                border: "none",
                background: "transparent",
                color: "#333",
                cursor: "pointer",
                padding: 0,
                lineHeight: 1,
              }}
            >
              &times;
            </button>

            <h2>Detalii Utilizator</h2>
            <p>
              <strong>Nume:</strong> {userDetails.nume || "Necunoscut"}
            </p>
            <p>
              <strong>Prenume:</strong> {userDetails.prenume || "Necunoscut"}
            </p>
            <p>
              <strong>Instituție:</strong> {userDetails.institutie || "Necunoscută"}
            </p>
            <p>
              <strong>Funcție:</strong> {userDetails.functie || "Necunoscută"}
            </p>
            <p>
              <strong>Telefon:</strong> {userDetails.telefon || "Necunoscut"}
            </p>
            <p>
              <strong>Email:</strong> {userDetails.email || "Necunoscut"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ButonIstoric;
